import { useContext, useEffect, useReducer, useState } from "react";
import { Modal, Typography, Input } from "antd";
import axios from "axios";
import InvitedUsers from "./InvitedUsers";
import { Background, ButtonWithImg, Icons, Layout, NavigationHeader, PrimaryButton } from "../../components";
import { Header } from "antd/lib/layout/layout";
import "./LinkInfra.scss";
import useProfile from "../../hooks/useSetUserProfile";
import { userProfileReducer, USER_PROFILE_DEFAULT_STATE } from "../../storage/reducers";
import { loginApi } from "../../api";
import { UserContext } from "../../storage/context";
import { useNavigate } from "react-router-dom";
import { URL_API_LINK_INFRA_INVITE } from "../../api/endpoints";
import { EmailModal } from "./EmailModal";
import CreatorInviteForm from "../../components/CreatorInviteForm/CreatorInviteForm";

const { Text } = Typography;

function LinkInfra() {
  const [showInviteUser, setShowInviteUser] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [emailsField, setEmailsField] = useState("");
  const { logoutUserProfile } = useProfile();
  const { userProfile } = useContext(UserContext);
  const navigate = useNavigate();

  const pushEmailsToInvite = async (emails) => {
    const parsedEmails = emails.map((email) => {
      return { email };
    });
    await axios.post(`${URL_API_LINK_INFRA_INVITE}`, parsedEmails);
    setShowInviteUser(false);
    // localStorage.setItem(emails);
  };

  const addEmailsToInvite = (e) => {
    setEmailsField(e.target.value);
  };

  const handleSendButtonClick = async (emailsField) => {
    const emails = emailsField.split(",").map((i) => i.trim());
    await pushEmailsToInvite(emails);
  };

  useEffect(() => {
    const hasLoggedIn = !!userProfile.user.emailVerified && !!userProfile.user.token;
    if (hasLoggedIn) logoutUserProfile();
    navigate("/link-demo");
  }, []);

  return (
    <Background rightLeaves leftLeaves rightScratched className="login-page">
      <NavigationHeader isAuthenticated={false} />
      <div className="add-account-btn-container">
        <h2>Your creators</h2>
        {/* <ButtonWithImg text="Invite creators" icon={Icons.plus} click={() => setShowInviteUser(true)} /> */}
        <PrimaryButton
          label="Invite Creators"
          onClick={() => {
            setIsModalVisible(true);
          }}
        />
      </div>
      <div className="invited-table">
        <InvitedUsers />
      </div>
      {/* <EmailModal handler={handleSendButtonClick} isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} /> */}
      <CreatorInviteForm
            open={isModalVisible}
            onClose={() => {
              setIsModalVisible(false);
            }}
            // setIsComplianceFormFilled={setIsComplianceFormFilled}
          />
    </Background>
  );
}

export default LinkInfra;
